import PageMeta from "@/components/seo/PageMeta";
import Hero from "@/pages/home/components/Hero";
import CategoryStrip from "@/pages/home/components/CategoryStrip";
import FeaturedCollections from "@/pages/home/components/FeaturedCollections";
import TrendingBoard from "@/pages/home/components/TrendingBoard";
import AboutStrip from "@/pages/home/components/AboutStrip";
import Testimonials from "@/pages/home/components/Testimonials";
import FaqSection from "@/pages/home/components/FaqSection";
import CtaBanner from "@/pages/home/components/CtaBanner";
import { collections } from "@/mocks/collections";
import { faqs, SITE_URL, siteInfo } from "@/mocks/site";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: siteInfo.name,
  url: SITE_URL,
  email: siteInfo.email,
  description:
    "吃瓜片场是围绕影视剧组花絮、路透、侧拍、彩蛋与候场片段的中文合集站，按分类整理正片之外的拍摄内容。",
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: siteInfo.name,
  url: SITE_URL,
  inLanguage: "zh-CN",
  description:
    "私拍吃瓜花絮、路透、侧拍、彩蛋与候场片段合集，按分类浏览更方便。",
  potentialAction: {
    "@type": "SearchAction",
    target: `${SITE_URL}/collections?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((item) => ({
    "@type": "Question",
    name: item.q,
    acceptedAnswer: {
      "@type": "Answer",
      text: item.a,
    },
  })),
};

const itemListSchema = {
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "吃瓜片场精选合集",
  itemListElement: collections.slice(0, 6).map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.title,
    url: `${SITE_URL}/collections/${item.id}`,
  })),
};

export default function Home() {
  return (
    <>
      <PageMeta
        title="吃瓜片场 | 私拍吃瓜花絮路透侧拍彩蛋候场合集"
        description="吃瓜片场整理私拍吃瓜花絮、路透、侧拍、彩蛋与候场片段，分成独立合集按分类浏览。想看正片之外的路透细节、侧拍说法与备料内容，从这里直接进。"
        keywords="私拍吃瓜,私拍吃瓜花絮,私拍吃瓜路透,私拍吃瓜侧拍,私拍吃瓜彩蛋,私拍吃瓜候场"
        path="/"
        jsonLd={[organizationSchema, websiteSchema, faqSchema, itemListSchema]}
      />
      <Hero />
      <CategoryStrip />
      <FeaturedCollections />
      <TrendingBoard />
      <AboutStrip />
      <Testimonials />
      <FaqSection />
      <CtaBanner />
    </>
  );
}